module.exports = "<div class=\"modal-header\">\r\n  <h3>Insert link</h3>\r\n  <hr>\r\n</div>\r\n<div class=\"modal-body\">\r\n  \r\n</div>\r\n";